<template>
  <div class="tag-list">
    <div class="tag-list__grid">
      <button
        type="button"
        v-for="(item, index) in items"
        class="tag-list__tag btn btn--round"
        :class="[`btn--${color}`, {'btn--tag': !item.active}]"
        @click="$emit('item-click', index)"
      >
        {{item.title}}
        <PlusIcon
          class="tag-list__icon"
          :class="{'tag-list__icon--active': item.active}" />
      </button>
    </div>
  </div>
</template>

<script>
  import PlusIcon from '../icons/PlusIcon.vue';

  export default {
    props: {
        items: {
            type: Array,
            required: true,
        },
        color: {
            type: String,
            default: "default",
        },
    },
    components: { PlusIcon },
}
</script>

<style lang="scss">
  @import "~styles/definitions";

  .tag-list {
    @include prevent-margin-collapse;
    gap: 0.5rem
  }

  .tag-list__grid {
    display: flex;
    gap: 0.5rem;
    flex-wrap: wrap;
  }

  .tag-list__tag {
    background-color: $color-green-lighter-2025;
    font-size: r(16);
    padding: r(10) r(16);
    line-height: r(20);
    font-weight: 500;
    color: $color-black;

    &:hover {
      background-color: $color-green-lighter-2025;
    }
  }

  .tag-list__icon {
    transition: transform 0.2s;

    &--active {
      transform: rotate(45deg);
    }
  }
</style>
